import React from 'react';
import { KPICard } from '../../ui';
import { useSatisfactionTotalSurveys } from '../../../hooks/useSatisfactionKPIs';
import LoadingSpinner from '../../ui/LoadingSpinner';
import { TimePeriod } from '../../../types/api';

import { KPIProps } from '../../../types/kpi';
const TotalSurveysKPI: React.FC<KPIProps> = ({
  branchId = 0,
  timeRange,
  onError,
  showLoading = true,
  className = ''
}) => {
  const { data, isLoading, isError, error, refetch } = useSatisfactionTotalSurveys(branchId, timeRange as TimePeriod);

  React.useEffect(() => {
    if (isError && error && onError) {
      onError(error as Error);
    }
  }, [isError, error, onError]);

  if (isLoading && showLoading) {
    return (
      <div className={`${className} animate-enter animate-delay-3`}>
        <div className="card-base card-padding">
          <div className="flex flex-col items-center justify-center h-32">
            <LoadingSpinner
              variant="minimal"
              size="md"
            />
          </div>
        </div>
      </div>
    );
  }

  if (isError || !data) {
    return (
      <div className={`${className} card-base border border-status-error p-4`}>
        <p className="text-status-error text-sm">خطا در بارگذاری تعداد نظرسنجی‌ها</p>
        {showLoading && (
          <button
            onClick={() => refetch()}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700"
          >
            تلاش مجدد
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={`${className} animate-enter-up stagger-1`}>
      <KPICard
        title="تعداد کل نظرسنجی‌ها"
        value={data.totalSurveys.toLocaleString('fa-IR')}
        variant="primary"
        accentStyle="corner"
        loading={isLoading && !showLoading}
        // subtitle=''
      />
    </div>
  );
};

export default TotalSurveysKPI;